module.exports = __webpack_public_path__ + "static/media/img-whatelse_on.3054ebcc.svg";